import styled from "styled-components";


const ArrowDown = styled.span`
    display: flex;
    min-width: 100%;
    align-items: center;
    justify-items: center;
    align-content: center;
    flex-direction: column;
    margin-bottom: 3vh;
`

export default ArrowDown